import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { useFetch } from '../hooks/useFetch'
import { db } from "../firebase/config"
import { collection, addDoc } from "firebase/firestore"
import { useAuthContext } from "../hooks/useAuthContext"



import './Questions.css'


export default function Questions() {


  //states
  const [answer, setAnswer] = useState([])
  const [score, setScore] = useState()
  const [showScore, setShowScore] = useState(false)
  const [url, setUrl] = useState('https://opentdb.com/api.php?amount=10&type=boolean')
  

  const { data } = useFetch(url)
  const { user } =  useAuthContext()
  const history = useHistory()

  const date = new Date()

  const months =  ["January","February","March","April","May","June","July","August","September","October","November","December"];

  const time = `${date.getHours()} : ${date.getMinutes()}`
  const day = `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`




  let qid = 1
  let scoreValue = 0


  
 //getting user input(answers)
  const handleChange = (e) =>{

    const value = e.target.value
    
    setAnswer((old)=>{
      return [...old, value]
    })
  }

  

  const checkAnswers = async () =>{

      data && data.forEach((element, index )=> {
  
        if(element.correct_answer ===answer[index]){
          scoreValue += 10
          setScore(scoreValue)

        }
        setScore(scoreValue)
        setShowScore(true)
        
        });

        const ref = collection(db, 'scores')

  user &&  await addDoc(ref,{
      score: score,
      id : user.uid,
      time : time,
      date : day
      
    })

  
  }

  useEffect(()=>{

    checkAnswers()

  },[score])
 
  

//submitting answers and adding score
const handleSubmit = (e) =>{
  e.preventDefault()
  
  checkAnswers()

}

const handleButton = () =>{
  history.push('/dashboard')
}
  
  return (
    <form onSubmit={handleSubmit} >
      {showScore &&<div className="popup-wrapper">
        <div className="popup">
            <div className="popup-content">
                <h2>You Scored</h2>
                <p>{score}%</p>
                <button onClick={handleButton} className='submit'>Go to Dashboard</button>
            </div>
        </div>
      </div>}
       <div className="heading">
        <h1>Questions</h1>
       </div>
      {data && data.map((question_data, id) =>(
        <div key={id}  className="question">
          <p dangerouslySetInnerHTML={{__html:`${qid}. ${question_data.question}`}}></p>
          <input type="radio" value='True' name={`q${qid}`} onClick={handleChange}/>
          <label htmlFor="q1">True</label>
          <br/>
          <input type="radio" value='False' name={`q${qid ++}`} onClick={handleChange}/>
          <label htmlFor="q1">False</label>
        </div>
      ))}
      <div className="submit">
        <button type="submit" className="submit">Submit</button>
      </div>
    </form>
  )
      }
